/* eslint-disable no-console */
import { ChangeCursor } from './styles';

import BlueMarker from './assets/blue-marker.svg';
import DarkBlueMarker from './assets/dark-blue-marker.svg';
import OrangeMarker from './assets/orange-marker.svg';

import AttributeTable from '../../../../AttributeTable';
import ButtonTooltip from '../../ButtonTooltip';

/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
/**
 * Importação da biblioteca axios para fazer requisições baseadas em Promises.
 */
import axios from 'axios';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 *
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 *
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 */
import { useState, useEffect, useCallback } from 'react';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useMap } from 'views/MapView/hooks';

const Icon = (props) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4228 17.1772C12.3274 17.4261 12.0794 17.5926 11.8005 17.5951C11.5219 17.5979 11.2704 17.4355 11.1703 17.1883L7.29415 7.6227C7.26731 7.5614 7.25018 7.49522 7.24485 7.42578C7.24463 7.42295 7.2444 7.42012 7.24417 7.41727C7.24319 7.40518 7.24219 7.39293 7.24219 7.38093V7.37406C7.24219 7.02559 7.54427 6.74512 7.91184 6.74512C8.00873 6.7453 8.10181 6.76447 8.18481 6.80009L18.2353 10.4766C18.4937 10.571 18.6633 10.8065 18.6633 11.069V11.075C18.6633 11.3399 18.4855 11.5757 18.2239 11.6658L13.9694 13.1345L12.4228 17.1772Z"
      fill="#BEC7DC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6429 3.23188C10.1521 0.741033 6.11925 0.741033 3.62841 3.23188C1.16129 5.699 1.13756 9.70807 3.58096 12.1989L8.12379 16.7417L8.78486 16.0807L9.32958 17.2202L8.13565 18.4142L2.75068 13.0292C-0.155304 10.0758 -0.131582 5.3313 2.79813 2.4016C5.75156 -0.551834 10.5197 -0.551834 13.4732 2.4016C14.9167 3.84517 15.6521 5.73138 15.6792 7.6275L14.4843 7.18432C14.3628 5.69069 13.7167 4.30573 12.6429 3.23188Z"
      fill="#BEC7DC"
    />
  </svg>
);

/**
 * Identifica as feiçoes contidas em todas as camadas importadas ou do
 * catalogo de camadas numa coordenada especifica, que é determinada
 * através do clique no mapa na região desejada.
 *
 * Usando o getFeatureInfo em camadas WMS, e os dados contidos no GeoJson em camadas vetoriais.
 *
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Seta o estado
 * @param {*} props Resto
 * @returns Retorna uma tabela na parte inferior da tela com as feiçoes de acordo
 * com as camadas importadas e o local selecionado.
 */
export const IdentifyFeature = ({
  mapContext,
  isActive,
  setIsActive,
  ...props
}) => {
  const [latlngMarker, setLatLngMarker] = useState(null);
  const [foundData, setFoundData] = useState(null);
  const [cursor, setCursor] = useState(DarkBlueMarker);
  const [searchingData, setSearchingData] = useState(false);


  const { setMobileCursor, setBottomPanelIsOpen } = mapContext;

  const { map, layers, setLoadingInMap } = useMap();

  /**
   * getFromWms
   *
   * @param {array} wmsLayers
   * @param {number} x
   * @param {number} y
   * @param {function} mapSize
   * @param {*} bboxString
   *
   * @returns
   */
  const getFromWms = async (wmsLayers, x, y, mapSize, bboxString) => {
    if (wmsLayers.length > 0) {
      let promises = [];
      let featuresInfo = {};
      wmsLayers.forEach((v) => {
        let layerNames = Object.keys(v.layers);
        featuresInfo = { ...featuresInfo, ...v.layers };
        let getFeatureInfoParams = {
          service: 'WMS',
          version: '1.1.1',
          request: 'GetFeatureInfo',
          layers: layerNames.join(','),
          styles: '',
          srs: 'EPSG:4326',
          bbox: bboxString,
          width: mapSize.x,
          height: mapSize.y,
          query_layers: layerNames.join(','),
          info_format: 'application/json',
          tiled: 'true',
          x,
          y,
          feature_count: 50,
        };

        promises.push(
          axios(v.baseUrl, {
            params: getFeatureInfoParams,
          })
            .then(({ data }) => ({
              data,
              raster: v.raster,
              id: v.raster ? layerNames[0] : null,
            }))
            .catch((e) => {
              console.error(
                'Erro ao indentificar camada(s):',
                layerNames.join(','),
                e
              );
              return null;
            })
        );
      });
      return await Promise.all(promises).then((values) => {
        //Obtém os nomes das camadas sem o workspace, para se igualar a resposta
        let layerNames = Object.keys(featuresInfo).reduce(
          (ac, k) => ({ ...ac, [k.split(':')[1]]: k }),
          {}
        );
        values.forEach((result) => {
          if (result && result.data.features?.length > 0) {
            result.data.features.forEach((feature) => {
              let layerName = result.raster
                ? result.id.split(':')[1]
                : feature.id.split('.')[0];
              if (featuresInfo[layerNames[layerName]]) {
                let featureProperties = feature.properties;
                let featureBbox = featureProperties.bbox || feature.bbox;
                if (featureBbox) {
                  if (
                    ['Point', 'MultiPoint'].includes(
                      featuresInfo[layerNames[layerName]].layer.dataType
                    )
                  )
                    featureProperties.bbox = L.latLng([
                      featureBbox[1],
                      featureBbox[0],
                    ]);
                  else
                    featureProperties.bbox = L.latLngBounds(
                      [featureBbox[1], featureBbox[0]],
                      [featureBbox[3], featureBbox[2]]
                    );
                }

                if (featuresInfo[layerNames[layerName]].featureInfo) {
                  featuresInfo[layerNames[layerName]].featureInfo.push(
                    featureProperties
                  );
                } else
                  featuresInfo[layerNames[layerName]].featureInfo = [
                    featureProperties,
                  ];
              } else {
                console.error(
                  'Falha ao listar propriedades da camada: ',
                  layerName,
                  layerNames
                );
              }
            });
          }
        });
        return Object.keys(featuresInfo).map((k) => featuresInfo[k]);
      });
    }
    return [];
  };

  const getFromGeoJson = useCallback(
    (vectorLayers, latlng, layerPoint) => {
      let newFoundData = [];
      if (vectorLayers.length > 0) {
        // Realiza buffer na area clicada para garantir a seleção
        const pxDistanceBuffer = 3;
        const measureCoord = map.layerPointToLatLng(
          L.point(layerPoint.x + pxDistanceBuffer, layerPoint.y)
        );
        const distanceBuffer = map.distance(latlng, measureCoord);
        const bufferedMarker = turf.buffer(
          turf.point([latlng.lng, latlng.lat]),
          distanceBuffer,
          { units: 'meters' }
        );
        let bufferBbox = turf.bbox(bufferedMarker);
        bufferBbox = turf.bboxPolygon(bufferBbox);

        vectorLayers.forEach((vl) => {
          let layerData = {
            layer: vl,
            featureInfo: [],
          };

          vl.leafletLayer.eachLayer((feature) => {
            let featureBbox = feature.getBounds && feature.getBounds();
            featureBbox = featureBbox && [
              featureBbox.getSouthWest().lng,
              featureBbox.getSouthWest().lat,
              featureBbox.getNorthEast().lng,
              featureBbox.getNorthEast().lat,
            ];
            if (
              turf.booleanIntersects(
                bufferBbox,
                featureBbox ? turf.bboxPolygon(featureBbox) : feature.feature
              )
            ) {
              turf.booleanIntersects(feature.feature, bufferBbox) &&
                layerData.featureInfo.push({
                  ...feature.feature.properties,
                  _feature: feature.feature,
                  bbox: feature.getBounds
                    ? feature.getBounds()
                    : feature.getLatLng(),
                });
            }
          });

          newFoundData.push(layerData);
        });
      }
      return newFoundData;
    },
    [map]
  );

  const getFeatureInfo = useCallback(
    async (mouseEvent) => {    
      if (!searchingData) {
        let wmsLayers = [];
        let vectorLayers = [];
        let x, y, latLng;
        let mapSize = map.getSize(); // para pegar o tamanho do mapa em pixels (x,y)
        let bboxString = map.getBounds().toBBoxString(); // para pegar o bounding box do mapa

        setSearchingData(true);
        setLoadingInMap(true);

        if (window.innerWidth <= 768) {
          x = Math.floor(mapSize.x / 2);
          y = Math.floor(mapSize.y / 2);
          latLng = map.containerPointToLatLng([x, y]);
        } else {
          x = Math.floor(mouseEvent.containerPoint.x);
          y = Math.floor(mouseEvent.containerPoint.y);
          latLng = mouseEvent.latlng;
        }
        let electivesLayers = layers.filter((l) => l.isSelected);
        electivesLayers =
          electivesLayers.length > 0
            ? electivesLayers.filter((l) => l.visible)
            : layers.filter((l) => l.visible);

        setLatLngMarker(latLng);
        electivesLayers.forEach((l) => {
          let bounds = l.getBoundingBox();
          bounds = bounds
            ? L.latLngBounds(
                [bounds.miny, bounds.minx],
                [bounds.maxy, bounds.maxx]
              )
            : map.getBounds();
          if (bounds.contains(latLng)) {
            if (l.getService() === 'WMS') {
              let baseUrl = l.getServiceLink();
              let added = false;
              wmsLayers.forEach((v) => {
                if (
                  !added &&
                  !v.raster &&
                  l.dataType?.toUpperCase() !== 'RASTER'
                ) {
                  if (
                    v.baseUrl === baseUrl &&
                    !v.layers[l.getLayerNameParam()]
                  ) {
                    v.layers[l.getLayerNameParam()] = { layer: l };
                    added = true;
                  } else if (
                    v.baseUrl === baseUrl &&
                    v.layers[l.getLayerNameParam()]
                  ) {
                    added = true;
                  }
                }
              });
              if (!added)
                wmsLayers.push({
                  baseUrl,
                  layers: { [l.getLayerNameParam()]: { layer: l } },
                  raster: l.dataType?.toUpperCase() === 'RASTER',
                });
            } else if (
              l.getService() === 'WFS' ||
              l.type === 'importada' ||
              l.type === 'criada'
            ) {
              vectorLayers.push(l);
            }
          }
        });
        let dataFromGeoJson = getFromGeoJson(
          vectorLayers,
          mouseEvent.latlng,
          mouseEvent.layerPoint
        );
        let dataFromWms = await getFromWms(
          wmsLayers,
          x,
          y,
          mapSize,
          bboxString
        );

        setFoundData([...dataFromGeoJson, ...dataFromWms]);
      }
    },
    [layers, map, getFromGeoJson, searchingData, setLoadingInMap]
  );

  const defineCursor = useCallback(
    (preset = 'auto') => {
      if (preset !== 'auto') {
        const cursors = {
          blue: BlueMarker,
          orange: OrangeMarker,
          darkBlue: DarkBlueMarker,
        };
        setCursor(cursors[preset]);
      } else {
        let haveData = false;
        foundData &&
          foundData.forEach((v) => {
            if (v.featureInfo && v.featureInfo.length > 0) haveData = true;
          });
        setCursor(
          foundData !== null
            ? haveData
              ? BlueMarker
              : OrangeMarker
            : DarkBlueMarker
        );
      }
    },
    [foundData]
  );

  useEffect(() => {
    if (isActive) {
      defineCursor();
    }
  }, [defineCursor, isActive]);

  useEffect(() => {
    if (foundData) {
      setBottomPanelIsOpen(
        true,
        'Identificar Feição',
        <AttributeTable
          dataTabs={foundData}
          map={map}
          changeCursor={defineCursor}
        />
      );
    } else setBottomPanelIsOpen(false);
    setSearchingData(false);
    setLoadingInMap(false);
  }, [foundData, setBottomPanelIsOpen, map, defineCursor, setLoadingInMap]);

  useEffect(() => {
    if (isActive) {
      map.on('click', getFeatureInfo);
      if (window.innerWidth <= 768) {
        setMobileCursor(<img src={cursor} alt="markerCursor" />);
      } else {
        setMobileCursor();
      }
    } else {
      setLatLngMarker(null);
      setMobileCursor();
      setFoundData(null);
      setSearchingData(false);
    }
    return () => map.off('click', getFeatureInfo);
  }, [isActive, map, getFeatureInfo, setMobileCursor, cursor]);

  useEffect(() => {
    let marker;
    if (latlngMarker && isActive) {      
      var myIcon = L.icon({
        iconUrl: cursor,
        iconSize: [27, 33],
        iconAnchor: [13, 28],
        popupAnchor: [-3, -76],
      });
      marker = L.marker(latlngMarker, { icon: myIcon }).addTo(map);
    }
    return () => marker && marker.remove();
  }, [latlngMarker, map, isActive, cursor]);

  return (
    <ButtonTooltip
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: 'none',
        width: '35px',
        height: '40px',
      }}
      tooltip={IdentifyFeature.properties.alias}
      description={IdentifyFeature.properties.description}
      onClick={() => setIsActive()}
      active={isActive}
      activeWithBgColor
    >
      <Icon width="24" height="24" />
      {isActive && <ChangeCursor cursor={cursor} />}
    </ButtonTooltip>
  );
};

IdentifyFeature.properties = {
  id: 'CPN-TB-A-IDENTIFY-FEATURE',
  alias: 'Identificar feição pelo mapa',
  description:
    'Realiza a identificação de feições com seus atributos clicando ná área desejada, podendo especificar camadas.',
};

export default IdentifyFeature;
